// React
import React, { useState } from "react";

// Redux
import { useDispatch } from "react-redux";
import { openSnackbar } from "Store/SnackbarSlice";
import { useTranslation } from "react-i18next"; // Import translation hook

// Styles
import { styles } from "./styles";

// MUI
import Button from "@mui/material/Button";
import CircularProgress from "@mui/material/CircularProgress";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";

// Resources
import { deactivatePatient } from "API/Resource/patient";

const DeactivatePatientModal = ({ open, patient, onClose, onConfirm }) => {
  const { t } = useTranslation();
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();

  const handleDeactivatePatient = async () => {
    try {
      setLoading(true);
      await deactivatePatient(patient.id);
      setLoading(false);
      onConfirm();
      dispatch(
        openSnackbar({
          message: t("deactivatePatientModal.successMessage"),
          severity: "success",
        })
      );
    } catch (error) {
      const errorMessages = {
        APPOINTMENT_TIME_PASSED: t(
          "deactivatePatientModal.appointmentTimePassed"
        ),
      };
      const defaultErrorMessage = t("errors.genericError");
      dispatch(
        openSnackbar({
          message: errorMessages[error.message] || defaultErrorMessage,
          severity: "error",
        })
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <Dialog open={open} onClose={onClose} sx={styles.dialog}>
      <DialogTitle sx={styles.dialogTitle}>
        {t("deactivatePatientModal.title")}
      </DialogTitle>
      <DialogContent>
        <DialogContentText>
          {t("deactivatePatientModal.confirmMessage")}
          <strong>{t("deactivatePatientModal.deactivate")}</strong>{" "}
          {patient.firstName} {patient.lastName} ?
        </DialogContentText>
        <DialogContentText color="error">
          {t("deactivatePatientModal.warning")}
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} variant="text" disabled={loading}>
          {t("buttons.cancel")}
        </Button>
        <Button
          onClick={handleDeactivatePatient}
          variant="contained"
          disabled={loading}
        >
          {loading ? (
            <>
              <CircularProgress size={"24px"} sx={styles.loading} />
              {t("buttons.sending")}
            </>
          ) : (
            t("deactivatePatientModal.deactivate")
          )}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default DeactivatePatientModal;
